export const appElement = 'afLogin';
